import React from 'react';
import { createQueryDataTable, type PropsOfQueryDataTable, type RowOfQueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import { baseTotalColumns } from '../../groups/GroupedTotalsColumn';
import { NeedsAssignedScheduleReportTable } from './NeedsAssignedTable';
import { GroupVisitsByDiscplineTable } from '../../groups/GroupVisitsByDiscplineTable';

const NeedsAssignedDisciplineDataTable = createQueryDataTable('schedule-report-totals-discpline-unassigned');
type RowType = RowOfQueryDataTable<typeof NeedsAssignedDisciplineDataTable>;

const columnDefinitions = NeedsAssignedDisciplineDataTable.columns([
	{
		header: 'Discipline',
		key: 'discipline',
		sortable: true
	},
	...baseTotalColumns<RowType>()
]);

export function NeedsAssignedDisciplineTable(props: PropsOfQueryDataTable<typeof NeedsAssignedDisciplineDataTable>) {
	return (
		<GroupVisitsByDiscplineTable
			columnDefinitions={columnDefinitions}
			searchType="schedule-report-totals-discpline-unassigned"
			tableComponent={NeedsAssignedScheduleReportTable}
			{...props}
		/>
	);
}
